// Carrinho.js — a gaveta do carrinho.
//
// O PORTAL É PELO MESMO MOTIVO DO MENU (ver shared/Menu.js): esta gaveta é
// montada dentro do <header>, que é `fixed`, tem `z-[101]` e um `transform` —
// e qualquer um dos três prende o `z-index` de tudo o que está dentro. Sem o
// portal, a barra de compra do celular (z-9998) passa por cima da gaveta.
import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import "./Carrinho.css";
import Close from "../../assets/imgs/close.svg";
import CarrinhoContent from "./CarrinhoContent";

const Menu = ({ toggleSidebar, isOpen, setIsOpen }) => {

  const sidebarRef = useRef(null);
  const closeSidebar = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      toggleSidebar();
      
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", closeSidebar);
    return () => {
      document.removeEventListener("mousedown", closeSidebar);
    };
  });

  const main = process.env.REACT_APP_MAIN;

  return createPortal(
    <>
      <CSSTransition in={isOpen} timeout={500} classNames="fade" unmountOnExit>
        <div className="carrinho-container">
          <div className="sidebar" ref={sidebarRef}>
            <button
              className="menu-toggle close-menu-btn"
              onClick={toggleSidebar}
            >
              <img src={Close} alt="Close" />
            </button>

            <CarrinhoContent onCloseCarrinho={toggleSidebar} />

          </div>
          <div className="curtain"></div>
        </div>
      </CSSTransition>
    </>,
    document.body
  );
};

export default Menu;
